import { loadStripe } from '@stripe/stripe-js/pure'

export async function getStripeObject() {
  const fraudFlag =
    !localStorage.getItem('cookie:accepted') == 'true' ? true : false
  loadStripe.setLoadParameters({ advancedFraudSignals: fraudFlag })
  return await loadStripe(process.env.VUE_APP_STRIPE_PUB_KEY)
}
